export default {
    DATE: 'MM/DD/YYYY',
    DATETIME: 'MM/DD/YYYY hh:mm A',
    DATETIME_SECS: 'MM/DD/YYYY hh:mm:ss',
    DATETIME_DATABASE: 'YYYY-MM-DD HH:mm:ss',
    HUMAN_READABLE: 'MMMM Do YYYY, h:mm:ss a',
    HUMAN_READABLE_SHORT_DATE: 'MMM D, YYYY',
    TIME: 'hh:mm A',
    QUERY_DATE: 'YYYY-MM-DD',
    QUERY_DATETIME: 'YYYY-MM-DD HH:mm:ss',
    QUERY_TIME: 'HH:mm:ss',
    MONTH_YEAR: 'MM/YY',
};
